<template>
    <div>
        <!-- Loading popup -->
         <div v-if="isLoading" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#52b2cf" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>

        
        <!-- Message popup for unavailable Tirzepatide dosages -->
        <div class="error_popup popup-desktop" v-if="showMessage" style="display:block;">
            <div class="error_box error-pop-desk">
                <img src="@/assets/images/info_icon_plan.png" loading="lazy" alt="" class="image-496">
                <div class="text-block-1101">Currently we do not offer {{planOptions.currentDose}}mg Dosages of Tirzepatide.</div>
                <div class="text-block-1102">Would you like to lock in our all industry low pricing for 10mg dosage of Tirzepatide?</div>
                <div class="button-model-yes-no">
                    <a data-w-id="e171a656-b153-7c5c-2d27-5fb3734ada93" href="#" class="button-107 w-button" @click.prevent="selectedYes()">Yes</a>
                    <a data-w-id="e171a656-b153-7c5c-2d27-5fb3734ada93" href="#" class="button-107 w-button" @click.prevent="moveToSorryPage()">No</a>
                </div>
            </div>
        </div>
        
        <!-- Navigation header -->
        <section class="simple-nav">
            <div class="simplenav_wrap">
                <div class="simplenav_flex">
                    <div class="nav-left-div">
                        <a href="#" class="link-block w-inline-block"><img src="@/assets/images/OhMyMeds_Logo_w.svg" loading="lazy" alt="" class="image-545"></a>
                    </div>
                </div>
            </div>
            <div class="nav-shadow"></div>
            <div class="mobile-nav-div">
                <div data-animation="default" data-collapse="medium" data-duration="400" data-easing="ease" data-easing2="ease" role="banner" class="navbar-mobile w-nav">
                    <a href="#" class="brand home w-nav-brand"><img src="@/assets/images/OhMyMeds_Logo_w.svg" loading="lazy" alt="" class="image-551"></a>
                </div>
                <div class="div-block-1958"></div>
            </div>
        </section>
        
        <!-- Main form section -->
        <div class="form-section">
            <div class="enroll-div-wrap">
                <!-- Step 1: Do you currently take any GLP Weight Loss Medications? -->
                <div class="question-container" v-if="active_el === 1">
                    <div class="question-category">
                        <div class="enroll-form-header-text">MEDICAL EVALUATION</div>
                    </div>
                    <div class="question-div-2">
                        <div class="text-block-1383 hq">Do you currently take any GLP Weight Loss Medications?<br></div>
                        <div class="felix-form-block w-form">
                            <form id="email-form" name="email-form" data-name="Email Form" method="get">
                                <div class="div-block-2039">
                                    <a href="#" class="button-131 w-button" @click.prevent="setValue('currentlyTakingGLP', 'Yes')">YES</a>
                                    <a href="#" class="button-131 w-button" @click.prevent="setValue('currentlyTakingGLP', 'No')">NO</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
    
                <!-- Step 2: What medication do you currently take? -->
                <div class="question-container" v-if="active_el === 2">
                    <div class="question-category">
                        <div class="enroll-form-header-text">MEDICAL EVALUATION</div>
                    </div>
                    <div class="question-div-2">
                        <div class="text-block-1383 hq">What medication do you currently take?</div>
                        <div class="felix-form-block w-form">
                            <form id="email-form" name="email-form" data-name="Email Form" method="get">
                                <a href="#" class="link-block-52 w-inline-block" @click.prevent="setValue('currentGLPMed', 'Semaglutide')">
                                    <div>
                                        <div class="text-block-1366">Ozempic / Wegovy</div>
                                    </div>
                                    <div>
                                        <div class="text-block-1355">-&gt;</div>
                                    </div>
                                </a>
                                <a href="#" class="link-block-52 w-inline-block" @click.prevent="setValue('currentGLPMed', 'Tirzepatide')">
                                    <div>
                                        <div class="text-block-1366">Mounjaro / Zepbound</div>
                                    </div>
                                    <div>
                                        <div class="text-block-1355">-&gt;</div>
                                    </div>
                                </a>
                                <a href="#" class="link-block-52 w-inline-block" @click.prevent="setValue('currentGLPMed', 'Semaglutide')">
                                    <div>
                                        <div class="text-block-1366">Semaglutide Compound</div>
                                    </div>
                                    <div>
                                        <div class="text-block-1355">-&gt;</div>
                                    </div>
                                </a>
                                <a href="#" class="link-block-52 w-inline-block" @click.prevent="setValue('currentGLPMed', 'Tirzepatide')">
                                    <div>
                                        <div class="text-block-1366">Tirzepatide Compound</div>
                                    </div>
                                    <div>
                                        <div class="text-block-1355">-&gt;</div>
                                    </div>
                                </a>
                            </form>
                        </div>
                    </div>
                    <div class="enroll-form-back-link-div">
                        <a href="#" class="enroll-form-back-link w-inline-block" @click.prevent="moveBack()">
                            <div class="enroll-form-back-text">&lt; Go Back</div>
                        </a>
                    </div>
                </div>
                
                <!-- Step 3: What dosage are you currently taking? -->
                <div class="question-container" v-if="active_el === 3">
                    <div class="question-category">
                        <div class="enroll-form-header-text">MEDICAL EVALUATION</div>
                    </div>
                    <div class="question-div-2">
                        <div class="text-block-1383 hq">What {{planOptions.currentGLPMed}} dosage are you currently taking?</div>
                        <div class="form-subs">❗To be approved for higher dosages, you must upload a clear photo of your current medication or past prescription showing your name and dosage. Without this, our doctors cannot legally prescribe an increased dose, and you must begin at the initial starter dosage schedule❗</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="setPlan()">
                                <select required class="select-field-9 w-select" v-model="planOptions.currentDose">
                                    <option value="">Select dose...</option>
                                    <option v-for="d in doseOption" :key="d" :value="d">{{d}} mg</option>
                                </select>
                                <input type="submit" data-wait="Please wait..." class="form-button w-button" value="Next -&gt;">
                            </form>
                        </div>
                        <div class="div-block-1941">
                            <div class="text-block-1127"><span class="text-span-240">Same Price. All Dosage Levels.</span><br>No Hidden Fees. Everything Included.</div>
                            
                        </div>
                    </div>
                    <div class="enroll-form-back-link-div">
                        <a href="#" class="enroll-form-back-link w-inline-block" @click.prevent="moveBack()">
                            <div class="enroll-form-back-text">&lt; Go Back</div>
                        </a>
                    </div>
                </div>
    
                <!-- Step 4: Choose your medication -->
                <div class="question-container form-rep" v-if="active_el === 4">
                    <div class="question-div-2">
                        <div class="text-block-1383 hq">Choose your medication:<br></div>
                        <div class="felix-form-block form-rep w-form">
                            <form id="email-form" name="email-form" data-name="Email Form" method="get" class="form-18">
                                <div class="program-choice-div products">
                                    <!-- Tirzepatide option - conditionally shown -->
                                    <a href="#" class="link-block-53 tirz _2box_leftdiv w-inline-block"  @click.prevent="setValue('selectedGLPMed', 'Tirzepatide')">
                                        <div class="div-block-2079 tirz">
                                            <div class="text-block-1395"><span class="text-span-324 tirz">Most Effective</span></div>
                                            <div class="form-product-3">Tirzepatide</div>
                                            <div class="text-block-1397">Compounded with B6 <br/>(Pyridoxine)</div>
                                            <p class="paragraph-173 report">Same active ingredient as <strong>Mounjaro® &amp; Zepbound®</strong></p>
                                            <div class="div-block-2080">
                                                <div>
                                                    <div class="div-block-2082"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="image-547">
                                                        <div class="bullet-text-4 _2"><strong>Up to 22% </strong>Weight Loss*</div>
                                                    </div>
                                                    <div class="div-block-2082"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="image-547">
                                                        <div class="bullet-text-4 _2">Works on <strong>2</strong> GLP Receptors.</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="div-block-2081"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-548">
                                                <div class="text-block-713">A once-weekly injection.</div>
                                            </div>
                                            <div class="div-block-2081"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-548">
                                                <div class="text-block-713">Most Effective GLP-1</div>
                                            </div>
                                            <div class="div-block-2081"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-548">
                                                <div class="text-block-713">Produced in the USA.</div>
                                            </div>
                                            <div class="text-block-1394">All Dosages Same Price</div>
                                            <div class="text-block-1398">2.5mg | 5mg | 7.5mg<br>10mg | 12.5mg | 15mg<br></div>
                                            <div class="text-block-1396">Starting at $195.75</div><input type="submit" data-wait="Please wait..." class="submit-button-7 w-button" value="Get Started">
                                        </div>
                                    </a>
                                    
                                    <!-- Semaglutide option - always shown -->
                                    <a href="#" class="link-block-53 sema _2 w-inline-block" @click.prevent="setValue('selectedGLPMed', 'Semaglutide')">
                                        <div class="div-block-2079 sema">
                                            <div class="text-block-1395"><span class="text-span-324 sema">Most Popular</span></div>
                                            <div class="form-product-3">Semaglutide</div>
                                            <div class="text-block-1397">Compounded with B12 <br/>(Cyanocobalamin)</div>
                                            <p class="paragraph-173 report">Same active ingredient as <strong>Ozempic® &amp; Wegovy®</strong></p>
                                            <div class="div-block-2080">
                                                <div>
                                                    <div class="div-block-2082"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="image-547">
                                                        <div class="bullet-text-4"><strong>Up to 16%</strong> Weight Loss</div>
                                                    </div>
                                                    <div class="div-block-2082"><img width="75.5" loading="lazy" alt="" src="@/assets/images/icon_Check-black.svg" class="image-547">
                                                        <div class="bullet-text-4">Works on <strong>1 </strong>GLP Receptor</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="div-block-2081"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-548">
                                                <div class="text-block-713">A once-weekly injection.</div>
                                            </div>
                                            <div class="div-block-2081"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-548">
                                                <div class="text-block-713">Most Prescribed GLP-1 </div>
                                            </div>
                                            <div class="div-block-2081"><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d5ee2be02f050e178d918_icon_Check.svg" alt="" class="image-548">
                                                <div class="text-block-713">Produced in the USA.</div>
                                            </div>
                                            <div class="text-block-1394">All Dosages Same Price</div>
                                            <div class="text-block-1398">.25mg | .5mg | 1mg<br>1.75mg | 2.5mg<br></div>
                                            <div class="text-block-1396">Starting at $106.66</div><input type="submit" data-wait="Please wait..." class="submit-button-7 w-button" value="Get Started">
                                        </div>
                                    </a>
                                </div>
                                
                            </form>
                        </div>
                    </div>
                    <div class="enroll-form-back-link-div">
                        <a href="#" class="enroll-form-back-link w-inline-block" @click.prevent="moveBack()">
                            <div class="enroll-form-back-text">&lt; Go Back</div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Error popup -->
        <div class="error_popup" v-if="showError">
            <div class="error_box"><img loading="lazy" src="@/assets/images/icon_check-x.svg" alt="" class="image-496">
                <div class="text-block-1101">Ooops...</div>
                <div class="text-block-1102">Something went wrong</div>
                <a href="#" class="button-107 w-button" @click.prevent="showError = false">OK</a>
                <a href="#" class="link-59">Why am I having this issue?</a>
            </div>
        </div>
        <div style="height: 420px;"></div>
    </div>
    </template>
    
    <script>
    import {
        mapActions,
        mapGetters
    } from 'vuex';
    import {
        getProductsByOffer
    } from '@/utils/productData';
    
    export default {
        data() {
            return {
                baseUrl: process.env.VUE_APP_API_ENDPOINT,
                showMessage: false,
                showError: false,
                active_el: 1,
                isLoading: false,
                planOptions: {
                    currentlyTakingGLP: '',
                    currentGLPMed: '',
                    selectedGLPMed: '',
                    selectedPlanTerms: '',
                    currentDose: ''
                }
            }
        },
        computed: {
            ...mapGetters(['user']),
            doseOption() {
                if (this.planOptions.currentGLPMed === 'Semaglutide') {
                    return [0.25, 0.5, 1, 2, 2.5];
                }
                return [2.5, 5, 7.5, 10, 12.5, 15];
            },
            bmi() {
                const heightInInches = parseFloat(this.user.height_inch);
                const weightInPounds = parseFloat(this.user.weight);
                return (weightInPounds / (heightInInches * heightInInches)) * 703;
            },
            showTirzepatideOption() {
                // Only show Tirzepatide if they're currently taking it
                return this.planOptions.currentGLPMed === 'Tirzepatide';
            }
        },
        watch: {
            active_el() {
                window.scrollTo(0, 0)
            }
        },
        methods: {
            ...mapActions([
                'setCartVisibility',
                'clearCart'
            ]),
            scrolltoTop() {
                setTimeout(function () {
                    window.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }, 100);
            },
            selectedYes() {
                this.showMessage = false;
                this.planOptions.selectedGLPMed = this.planOptions.currentGLPMed;
                this.moveToCheckout();
            },
            setPlan() {
                if (this.planOptions.currentDose == null) {
                    return false;
                }
                
                // Check BMI
                if (this.bmi < 20) {
                    this.addTagForDisqualify();
                    this.$router.push({
                        name: 'leadDisqualified',
                        query: {
                            message: "We cannot proceed since your BMI is less than 20."
                        }
                    });
                    return false;
                } else {
                    this.planOptions.selectedGLPMed = this.planOptions.currentGLPMed;
                    localStorage.setItem('currentMed', JSON.stringify({
                        med: this.planOptions.currentGLPMed,
                        dose: this.planOptions.currentDose
                    }));
                    
                    // Check for unavailable Tirzepatide dosages
                    if (this.planOptions.currentGLPMed === 'Tirzepatide' && 
                        ![2.5, 5, 7.5, 10, 12.5, 15].includes(parseFloat(this.planOptions.currentDose))) {
                        this.showMessage = true;
                        return false;
                    }
                    
                    // Move to selection screen
                    this.moveNext(1);
                }
            },
            async setValue(field, value) {
                this.planOptions[field] = value;
                
                if (field === 'currentlyTakingGLP') {
                    if (value === 'No') {
                        // Check BMI for new users
                        if (this.bmi < 25) {
                            this.addTagForDisqualify();
                            this.$router.push({
                                name: 'leadDisqualified',
                                query: {
                                    message: "We cannot proceed since your BMI is less than 25."
                                }
                            });
                            return false;
                        }
                        // Skip to medication selection
                        this.moveNext(3);
                    } else {
                        // Move to next step
                        this.moveNext(1);
                    }
                } else if (field === 'selectedGLPMed') {
                    // Move to checkout
                    this.moveToCheckout();
                } else {
                    // For other fields, just move to next step
                    this.moveNext(1);
                }
            },
            addTagForDisqualify() {
                this.$axios.get(`${this.baseUrl}/forms/add-disqualify`);
            },
            moveToSorryPage() {
                this.$router.push("/sorry?message=We're truly sorry to see you go. We'll notify you as soon as the doses are available.")
            },
            async moveToCheckout() {
                await this.clearCart();
    
                try {
                    let plan = await this.getPlanByOffer();
                    const cartItem = {
                        id: plan.id,
                        name: plan.name,
                        category: plan.category.primary,
                        price: plan.pricing.retail_price,
                        retail_price: plan.pricing.retail_price,
                        subheader: 'Compound Medication',
                        sku: plan.sku,
                        stripe_id: plan.stripe_id,
                        quantity: 1,
                        image: `https://ohmymeds.s3.us-east-2.amazonaws.com/public/assets/product_image/webp/${plan.image_pre_text}/1.webp`,
                        main_type: 1,
                    };
                    try {
                        if (window.tracking) {
                            window.tracking.event('add_to_cart', {});
                        }
                    } catch (error) {
                        console.log(error)
                    }
                    this.saveCart(cartItem);
                } catch (error) {
                    console.error("Error preparing checkout:", error);
                    this.showError = true;
                }
            },
            getPlanByOffer() {
                try {
                    let offer = this.$store.getters.offerTir;
                    if (this.planOptions.selectedGLPMed === 'Semaglutide') {
                        offer = this.$store.getters.offerSema;
                    }
                    let product = getProductsByOffer(offer);
                    return product[0]
                } catch (error) {
                    console.log("error getting product ", error.message);
                    throw error;
                }
            },
            saveCart(cartItem) {
                this.isLoading = true;
                let postData = {
                    ...cartItem,
                    sema_offer: this.$store.getters.offerSema,
                    tir_offer: this.$store.getters.offerTir,
                    currentGLPMed: this.planOptions.currentGLPMed,
                    currentDose: this.planOptions.currentDose,
                };
    
                this.$axios.post(`${this.baseUrl}/forms/save-cart`, postData, {
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    })
                    .then(response => {
                        if (response.data.status === 'success') {
                            
                            this.$store.dispatch('addToCart', cartItem);
                            this.setCartVisibility(false);
                            this.isLoading = false;
                            this.$router.push({
                                name: 'checkoutWeightLoss',
                                params: {
                                    cart_id: response.data.id
                                }
                            });
                        } else {
                            this.showError = true;
                            this.isLoading = false;
                        }
                    })
                    .catch(error => {
                        this.showError = true;
                        this.isLoading = false;
                        console.error("Error saving cart:", error.message);
                    });
            },
            moveNext(step) {
                this.active_el = this.active_el + step;
            },
            moveBack() {
                if (this.active_el > 1) {
                    this.active_el = this.active_el - 1;
                }
            }
        }
    }
    </script>
    
    <style scoped>
    /* Center styling for single option */
    .program-choice-div.single-option {
        display: flex;
        justify-content: center;
    }
    .centered-option {
        margin: 0 auto;
        max-width: 450px;
    }
    </style>